import { BaseState } from "./BaseState";
import { StateManager } from "../GameStateManager";

class RaceInProgressState extends BaseState<StateManager> {
  public id = "RaceInProgressState"; // A unique identifier for the state
  constructor(stateManager: StateManager) {
    super(stateManager); // Pass the StateManager to the base class
  }

  public onEnter(stateManager: StateManager): void {
    this.stateManager = stateManager;
    super.onEnter(stateManager); // Call the super method
    this.stateManager.enteredRaceInProgressState();
  }
  public onExit(): void {
    super.onExit();
  }
}
export { RaceInProgressState };
